export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const SET_ERROR_PAGE = "SET_ERROR_PAGE";
export const SET_ERROR_MODAL_CLICKED = "SET_ERROR_MODAL_CLICKED";
